import React from "react";
import { Card, Progress, Typography, Space, Row, Col } from "antd";
import {
  HomeOutlined,
  CoffeeOutlined,
  BulbOutlined,
  ExperimentOutlined,
} from "@ant-design/icons";
import CustomCard from "../../blocks/Card/Card";

const { Text, Title } = Typography;

const roomData = [
  {
    name: "Kitchen",
    icon: <ExperimentOutlined />,
    condition: 90,
    color: "#52c41a",
  },
  {
    name: "Bathroom",
    icon: <BulbOutlined />,
    condition: 60,
    color: "#faad14",
  },
  {
    name: "Bedroom",
    icon: <CoffeeOutlined />,
    condition: 75,
    color: "#1890ff",
  },
  { name: "Overall", icon: <HomeOutlined />, condition: 80, color: "#722ed1" },
];

const PropertyConditionCard = () => {
  return (
    <CustomCard
      title={<Title level={5}>Property Condition</Title>}
      className="card-height"
    >
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        <Text>
          Based on image analysis, the property is in good overall condition.
        </Text>
        <Row gutter={[16, 16]}>
          {roomData.map((room) => (
            <Col span={12} key={room.name}>
              <Card size="small">
                <Space
                  direction="vertical"
                  style={{ width: "100%", textAlign: "center" }}
                >
                  <Title level={4}>
                    {room.icon} {room.name}
                  </Title>
                  <Progress
                    type="circle"
                    percent={room.condition}
                    strokeColor={room.color}
                  />
                  <Text>{getConditionDescription(room.condition)}</Text>
                </Space>
              </Card>
            </Col>
          ))}
        </Row>
        <Text type="secondary">
          Note: The kitchen appears to be the best-maintained room, while the
          bathroom might benefit from some updates.
        </Text>
      </Space>
    </CustomCard>
  );
};

const getConditionDescription = (condition) => {
  if (condition >= 90) return "Excellent";
  if (condition >= 75) return "Very Good";
  if (condition >= 60) return "Good";
  if (condition >= 40) return "Fair";
  return "Needs Improvement";
};

export default PropertyConditionCard;
